import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { resolveSocketUrl } from '../services/socketUrl';
import { AuthContext } from './AuthContext';

const SOCKET_URL = resolveSocketUrl();

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
    const { user } = useContext(AuthContext);
    const socketRef = useRef(null);
    const [socket, setSocket] = useState(null);
    const [connected, setConnected] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('1App_token');
        if (!token) return undefined;
        const socket = io(SOCKET_URL, {
            auth: { token },
            // Start with polling so proxies without WebSocket upgrades still work.
            transports: ['polling', 'websocket'],
            reconnectionAttempts: Infinity,
            reconnectionDelay: 2000,
            // Authentication uses the JWT above; cross-origin cookies are not needed.
            withCredentials: false,
        });

        socketRef.current = socket;
        setSocket(socket);

        socket.on('connect', () => setConnected(true));
        socket.on('connect_error', error => {
            console.error('[Socket] connection failed:', error.message);
            setConnected(false);
        });
        socket.on('disconnect', () => setConnected(false));

        const heartbeat = () => {
            if (socket.connected && user?.role === 'technician') socket.emit('technician:heartbeat', {});
        };
        socket.on('connect', heartbeat);
        const heartbeatTimer = setInterval(heartbeat, 30000);
        if (user?.role === 'technician' && user._id) {
            socket.on('connect', () => socket.emit('technician:join', user._id));
            if (socket.connected) socket.emit('technician:join', user._id);
        }

        if (user?.role === 'user' && user._id) {
            socket.on('connect', () => socket.emit('user:join', user._id));
            if (socket.connected) socket.emit('user:join', user._id);
        }

        return () => {
            clearInterval(heartbeatTimer);
            if (user?.role === 'user' && user._id) {
                socket.emit('user:leave', user._id);
            }
            if (user?.role === 'technician' && user._id) {
                socket.emit('technician:leave', user._id);
            }
            socket.disconnect();
            socketRef.current = null;
            setSocket(null);
            setConnected(false);
        };
    }, [user]);

    return (
        <SocketContext.Provider value={{ socket, connected }}>
            {children}
        </SocketContext.Provider>
    );
};

export const useSocket = () => useContext(SocketContext);
